let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Xrzp")).then(() => parcelRequire('ku91u'));